import {Cureus} from '../Cureus';

Cureus.AdminArticleReviewers = {};

//= require_tree ./AdminArticleReviewers